/**
 * Streamlines adding a dynamic value to `flex-direction`.
 *
 * @param {object} param0
 * @param {("row" | "row-reverse" | "column" | "column-reverse")} param0.$flexDirection
 * @returns {string}
 */

const dynFlexDirection = ({ $flexDirection }) => {
  if ($flexDirection === undefined) return "";
  return `flex-direction: ${$flexDirection};`;
};

export default dynFlexDirection;
